<template>
    <div ref="formcard"></div>
    <v-card class="py-4 w-100 align-center" :class="$vuetify.display.mobile ? 'px-0' : 'px6'">
        <v-card-title class=" text-h4 text-end mb-4">FELADATOK</v-card-title>
        <v-card-text>
            <v-divider></v-divider>
            <FormsComponent></FormsComponent>
        </v-card-text>
    </v-card>
</template>

<script>
import { defineComponent } from "vue";
import FormsComponent from "../components/FormsComponent.vue";

export default defineComponent({
    name: 'TasksPage',
    components: {
        FormsComponent,
    },
    data() {
        return {
            selectedTask: null,
        };
    },
});
</script>
